export const ForYouBrowseNudge = () => (
  <span
    className='mc-mr-2 d-inline-block mc-corners--circle'
    style={{
      width: 8,
      height: 8,
      background: 'var(--mc-color-primary-default)',
    }}
  />
)
